import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const Wrapper = styled.div`
  border-top: ${({ theme }) => `1px solid ${theme.default.color.text.light}`};
  border-bottom: ${({ theme }) => `1px solid ${theme.default.color.text.light}`};
  padding: 20px 0;
  display: grid;
  grid-template-columns: 5fr 1fr;
  a {
    word-break: normal;
    margin: 0;  
    text-transform: capitalize;
    color: ${({ theme }) => theme.default.color.text.dark};  
  }
`;

export const InnerWrapper = styled.div`

  @media (max-width: ${defaultBreakpoints.medium}) {
    max-width: 95vw;
  }
`;

export const Title = styled.span`
  p {
    font-family: ${({ theme }) => theme.default.fontFamily.primaryFont};
    font-size: 12px;
    font-weight: 800;
    line-height: 12px; 
    text-transform: uppercase;
    margin: 5px 0;  
  }
  span {
    word-break: normal !important;
    margin-left: 0;
    margin-right: 8px;
    color: ${({ theme }) => theme.default.color.text.dark};
    font-family: ${({ theme }) => theme.default.fontFamily.primaryFont};
    font-weight: 600;
  }  
`;

export const Tag = styled.a`
  // margin: auto 0.2rem;
  margin-right: 10px;
  margin-left: 10px;
  color: ${({ theme }) => theme.default.color.text.large};
  font-size: 14px;
  cursor: pointer;
  align-items: center;
  display: flex;
  :hover {
    text-decoration: underline;
  }
`;

export const SharingWrapper = styled.span`
  font-size: 0.8rem;
  margin: auto 0;  
  svg {
    font-size: 20px;
    width: 25px;
    height: 25px;  
  }
`;
